import { useQuery } from '@tanstack/react-query';
import { useCzechSuklRsAtcGroupsAutocomplete } from '~/libs/infrastructure/api/availability';

import { buildSlugFromLabel } from '../utils/availabilitySlug';
import { fetchSearchAutocompleteOptions } from '../utils/fetchAllSearchAutocompleteOptions';

const SEARCH_OPTIONS_QUERY_KEY = ['availability-search-options'] as const;

export function useAvailabilitySearchOptions(trimmedFilter: string, isOpen: boolean, disabled: boolean) {
	const isFilterTooShort = trimmedFilter.length === 1;
	const useAutocomplete = trimmedFilter.length > 1;

	const optionsQuery = useQuery({
		queryKey: SEARCH_OPTIONS_QUERY_KEY,
		queryFn: fetchSearchAutocompleteOptions,
		enabled: !disabled && isOpen && trimmedFilter.length === 0,
		staleTime: Infinity,
	});

	const autocompleteQuery = useCzechSuklRsAtcGroupsAutocomplete(
		{ filter: trimmedFilter, perPage: 100 },
		{ query: { enabled: !disabled && isOpen && useAutocomplete } }
	);

	if (useAutocomplete) {
		return {
			items: (autocompleteQuery.data?.items ?? []).map((item) => ({
				id: item.id,
				label: item.label,
				slug: buildSlugFromLabel(item.label),
			})),
			totalCount: autocompleteQuery.data?.pagination.total ?? 0,
			isFetching: autocompleteQuery.isFetching,
			isError: autocompleteQuery.isError,
			isFilterTooShort,
		};
	}

	return {
		items: optionsQuery.data?.items ?? [],
		totalCount: optionsQuery.data?.totalCount ?? 0,
		isFetching: optionsQuery.isFetching,
		isError: optionsQuery.isError,
		isFilterTooShort,
	};
}
